import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CheckboxMaterial from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

class Checkbox extends Component {
  render() {
    // const { classes } = this.props;

    return (
      <FormControlLabel
        control={
          <CheckboxMaterial
            checked={this.props.checked}
            checkedIcon={this.props.checkedIcon}
            onChange={this.props.onCheck}
            disabled={this.props.disabled}
            style={this.props.style}
            color="primary"
          />
        }
        label={this.props.label}
      />
    );
  }
}

const styles = {

};

Checkbox.propTypes = {
  // classes: PropTypes.object,
  checked: PropTypes.bool,
  style: PropTypes.object,
  onCheck: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  // classes: {},
  checked: false,
  style: {},
  onCheck: () => {},
  label: '',
  disabled: false,
};

export default withStyles(styles)(Checkbox);




// WEBPACK FOOTER //
// ./src/app/components/checkbox/checkbox.js